var map = {
	"./letra-p.png": "86c9",
	"./lista-de-afazeres.png": "909c",
	"./medalha.png": "b439",
	"./mpox.gif": "fd37",
	"./pilulas.png": "b02c",
	"./ponto-de-interrogacao.png": "0856",
	"./recompensa.png": "dc2f",
	"./saude.png": "f4ad",
	"./sintomas.png": "7791",
	"./sobre-nos.png": "0489",
	"./video.png": "62d9",
	"./violencia.png": "9d89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";